import { isNumber, isString, toNumber } from "@visactor/vutils";

import { defaultKeyStyle, defaultContentColumnStyle, defaultValueStyle, defaultAdaptiveKeyStyle, defaultShapeStyle } from "./style-constants";

import { BaseTooltipModel } from "./base-tooltip-model";

import { ShapeModel } from "./shape-model";

import { TextModel } from "./text-model";

import { TOOLTIP_EMPTY_STRING } from "../../constants";

import { getPixelPropertyStr } from "../utils";

import { mergeSpec } from "@visactor/vutils-extension";

const defaultLabelStyle = {
    overflowWrap: "normal",
    wordWrap: "normal"
};

export class ContentColumnModel extends BaseTooltipModel {
    constructor(parent, option, className, childIndex) {
        super(parent, option, childIndex), this.className = className;
    }
    init() {
        var _a, _b;
        this.product || (this.product = this.createElement("div", [ this.className ]));
        const renderContent = null !== (_b = null === (_a = this._option.getTooltipActual()) || void 0 === _a ? void 0 : _a.content) && void 0 !== _b ? _b : [];
        if ("shape-box" !== this.className || renderContent.some((c => c.hasShape && c.shapeType))) {
            Object.keys(this.children).forEach((key => {
                const i = toNumber(key);
                i >= renderContent.length && (this.children[i].release(), delete this.children[i]);
            }));
            for (let i = 0; i < renderContent.length; i++) if (!this.children[i]) if ("key-box" === this.className || "value-box" === this.className) {
                const text = new TextModel(this.product, this._option, i);
                text.init([ this.className.substring(0, this.className.indexOf("-")) ], void 0, "div"), 
                this.children[i] = text;
            } else if ("shape-box" === this.className) {
                const shape = new ShapeModel(this.product, this._option, i);
                shape.init([ "shape" ], void 0, "div"), this.children[i] = shape;
            }
        } else Object.keys(this.children).forEach((key => {
            const i = toNumber(key);
            this.children[i].release(), delete this.children[i];
        }));
    }
    setStyle() {
        var _a, _b, _c, _d;
        const tooltipStyle = this._option.getTooltipStyle();
        super.setStyle(mergeSpec({}, defaultContentColumnStyle, tooltipStyle.content, this._getContentColumnStyle()));
        const renderContent = null !== (_b = null === (_a = this._option.getTooltipActual()) || void 0 === _a ? void 0 : _a.content) && void 0 !== _b ? _b : [], contentAttributes = null !== (_d = null === (_c = this._option.getTooltipAttributes()) || void 0 === _c ? void 0 : _c.content) && void 0 !== _d ? _d : [], getKeyItemStyle = (line, i) => {
            var _a, _b;
            const {key: key, isKeyAdaptive: isKeyAdaptive} = line, {height: height} = contentAttributes[i], {keyColumn: keyColumn} = tooltipStyle, style = mergeSpec({}, isKeyAdaptive ? defaultAdaptiveKeyStyle : defaultKeyStyle, Object.assign(Object.assign(Object.assign({
                height: getPixelPropertyStr(height)
            }, defaultLabelStyle), keyColumn.common), null === (_a = keyColumn.items) || void 0 === _a ? void 0 : _a[i]));
            return isString(key) && "" !== (null === (_b = null == key ? void 0 : key.trim) || void 0 === _b ? void 0 : _b.call(key)) || isNumber(key) || style.visibility ? style.visibility = "visible" : style.visibility = "hidden", 
            style;
        };
        renderContent.forEach(((line, i) => {
            var _a;
            "key-box" === this.className ? this.children[i].setStyle(getKeyItemStyle(line, i)) : "value-box" === this.className ? this.children[i].setStyle(((line, i) => {
                var _a;
                const {height: height} = contentAttributes[i], {valueColumn: valueColumn} = tooltipStyle;
                return mergeSpec({}, defaultValueStyle, Object.assign(Object.assign(Object.assign({
                    height: getPixelPropertyStr(height)
                }, defaultLabelStyle), valueColumn.common), null === (_a = valueColumn.items) || void 0 === _a ? void 0 : _a[i]));
            })(0, i)) : "shape-box" === this.className && (null === (_a = this.children[i]) || void 0 === _a || _a.setStyle(((line, i) => {
                var _a, _b, _c, _d;
                const {height: height} = contentAttributes[i], {shapeColumn: shapeColumn} = tooltipStyle, keyStyle = getKeyItemStyle(line, i), paddingTop = `calc((${null !== (_b = null !== (_a = keyStyle.lineHeight) && void 0 !== _a ? _a : keyStyle.fontSize) && void 0 !== _b ? _b : "18px"} - ${null !== (_c = shapeColumn.width) && void 0 !== _c ? _c : "8px"}) / 2)`;
                return mergeSpec({}, defaultShapeStyle, Object.assign(Object.assign({
                    height: getPixelPropertyStr(height),
                    paddingTop: paddingTop
                }, shapeColumn.common), null === (_d = shapeColumn.items) || void 0 === _d ? void 0 : _d[i]));
            })(line, i), this._getShapeSvgOption(line, i)));
        }));
    }
    setContent() {
        var _a, _b, _c, _d;
        const renderContent = null !== (_b = null === (_a = this._option.getTooltipActual()) || void 0 === _a ? void 0 : _a.content) && void 0 !== _b ? _b : [], contentAttributes = null !== (_d = null === (_c = this._option.getTooltipAttributes()) || void 0 === _c ? void 0 : _c.content) && void 0 !== _d ? _d : [];
        renderContent.forEach(((line, i) => {
            var _a, _b, _c, _d, _e, _f, _g;
            let childContent;
            if ("key-box" === this.className) {
                const keyContent = line.key;
                childContent = isString(keyContent) && "" !== (null === (_a = null == keyContent ? void 0 : keyContent.trim) || void 0 === _a ? void 0 : _a.call(keyContent)) || isNumber(keyContent) ? keyContent : TOOLTIP_EMPTY_STRING, 
                null === (_b = this.children[i]) || void 0 === _b || _b.setContent(childContent, null === (_c = contentAttributes[i].key) || void 0 === _c ? void 0 : _c.multiLine);
            } else if ("value-box" === this.className) {
                const valueContent = line.value;
                childContent = isString(valueContent) && "" !== (null === (_d = null == valueContent ? void 0 : valueContent.trim) || void 0 === _d ? void 0 : _d.call(valueContent)) || isNumber(valueContent) ? valueContent : TOOLTIP_EMPTY_STRING, 
                null === (_e = this.children[i]) || void 0 === _e || _e.setContent(childContent, null === (_f = contentAttributes[i].value) || void 0 === _f ? void 0 : _f.multiLine);
            } else "shape-box" === this.className && (childContent = this._getShapeSvgOption(line, i), 
            null === (_g = this.children[i]) || void 0 === _g || _g.setContent(childContent));
        }));
    }
    _getContentColumnStyle() {
        var _a, _b;
        const tooltipStyle = this._option.getTooltipStyle();
        switch (this.className) {
          case "shape-box":
            const renderContent = null !== (_b = null === (_a = this._option.getTooltipActual()) || void 0 === _a ? void 0 : _a.content) && void 0 !== _b ? _b : [];
            return Object.assign(Object.assign({}, tooltipStyle.shapeColumn), "shape-box" !== this.className || renderContent.some((c => c.hasShape && c.shapeType)) ? {} : {
                display: "none"
            });

          case "key-box":
            return tooltipStyle.keyColumn;

          case "value-box":
            return tooltipStyle.valueColumn;
        }
    }
    _getShapeSvgOption(line, index) {
        var _a, _b;
        const tooltipStyle = this._option.getTooltipStyle(), shapeColumn = Object.assign(Object.assign({}, tooltipStyle.shapeColumn), null === (_a = tooltipStyle.shapeColumn.items) || void 0 === _a ? void 0 : _a[index]);
        return {
            hasShape: line.hasShape,
            symbolType: line.shapeType,
            size: shapeColumn.width,
            fill: null !== (_b = line.shapeFill) && void 0 !== _b ? _b : line.shapeColor,
            stroke: line.shapeStroke,
            lineWidth: line.shapeLineWidth,
            hollow: line.shapeHollow,
            index: index
        };
    }
}
//# sourceMappingURL=content-column-model.js.map
